<template>
  <div class="account-page mpk-form" >
    <form v-if="form">
      <AccountPanel title="Adres dostawy">
        <div class="col-12">
          <div class="row" v-if="form">
            <div class="col-12">
              <div class="form-group">
                <label for="name">Nazwa</label>
                <input id="name" name="name" class="form-control" type="text" required v-model="form.name.value"
                       @blur="validateField($event, form.name)" />
                <span class="invalid-feedback" v-if="form.name.errors.required">Pole nie może być puste</span>
              </div>
            </div>
          </div>
          <div class="row" v-if="form">
            <div class="col-12">
              <div class="form-group">
                <label>Budżet</label>
                <select v-model="form.budget.value" id="budget" name="budget" required class="form-control" @blur="validateField($event, form.budget)" >
                  <option v-for="budget in company.budgets.map(b => b.budget)" :value="budget">{{ budget.name }}</option>
                </select>
                <span class="invalid-feedback" v-if="form.budget.errors.required">Pole nie może być puste</span>
              </div>
            </div>
          </div>
          <div class="row" v-if="form">
            <div class="col-12 contact-prefer">
              <div class="contact_button">
                <button class="btn btn-primary" :disabled="!submittable" @click="submit" right>Zapisz</button>
              </div>
            </div>
          </div>
        </div>
      </AccountPanel>
    </form>
  </div>
</template>

<script>

  import Form from "../../../form/src/Form";
  import AccountPanel from './AccountPanel.vue'
  import { mapState } from 'vuex';

  export default {
    components: {AccountPanel},

    data () {
      return {
        form: Form.build({
            name: '',
            budget: ''
        }),
        submitted: false,
        progress: false
      }
    },
    computed: {
      submittable () {
        return !this.progress && !this.submitted
      },
      ...mapState({
        company: state => state.company,
      }),
    },
    methods: {
      ...Form.methods(),
      async submit (evt) {
        evt.preventDefault(); //prevent modal close
        let data = this.validateForm(evt, this.form);
        if(data) {
          this.progress = true;
          this.submitted = true;
          data.budget = {id: data.budget.id};
          await this.$store.dispatch('company/creatempk', data);
          this.progress = false;
          this.submitted = false;
          this.$router.replace({name: 'mpks'});
        }

      }
    },
    async beforeMount() {
      if (!this.$store.state.user.authorizedUser) {
        this.$router.replace({name: 'mainPage'});
      }
      await this.$store.dispatch('company/budgets');

    },



  }
</script>



// WEBPACK FOOTER //
// src/components/account/src/account/MpkForm.vue